// Material
import { AppBar, Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { RoundedOutlinedButton } from '$common/buttons'
import { SaveIcon } from '$common/icons/save'
// Components
import { EditAccountBackButton } from './edit-account-back-button'
// Localization
import { t } from '$i18n'
import { AvatarSize } from '$common/avatar/avatar-base/types.ts'

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 58,
  padding: '8px 15px 0',
  justifyContent: 'space-between',

  [theme.breakpoints.up('sm')]: {
    minHeight: 58,
    padding: '8px 15px 0',
  },
}))

export function EditAccountAppBar({
  onSave,
  onBack,
}: {
  onSave: () => unknown
  onBack: () => unknown
}) {
  return (
    <AppBar>
      <StyledToolbar disableGutters>
        <EditAccountBackButton onClick={onBack} />
        <RoundedOutlinedButton
          title={t('myAccountEdit.save')}
          icon={<SaveIcon />}
          onClick={onSave}
          color="neutral000"
          size={AvatarSize.XS}
        />
      </StyledToolbar>
    </AppBar>
  )
}
